import { fetchWithAuth } from "../utils/fetchWithAuth";

export const getAllEmails = async () => {
  try {
    const response = await fetchWithAuth("/mail/get-sent-mails", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      return {
        error: true,
        message: `Error al obtener correos: ${response.statusText}`,
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching emails:", error);
    throw error;
  }
}

export const getQuotasEmails = async () => {
    try {
        const response = await fetchWithAuth(`/mail/get-quotas-mails`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            return {
                error: true,
                message: `Error al obtener correos de la cuota: ${response.statusText}`,
            };
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching quota emails:", error);
        throw error;
    }
}

export const sendEmail = async (emailData) => {
  try {
    const response = await fetchWithAuth("/mail/send", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(emailData),
    });

    if (!response.ok) {
      return {
        error: true,
        message: `Error al enviar correo de prueba: ${response.statusText}`,
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Error sending test email:", error);
    throw error;
  }
}

export const sendTestQuotaEmail = async (emailData) => {
  try {
    const response = await fetchWithAuth("/mail/send-test-quotas", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({dto: emailData}),
    });

    if (!response.ok) {
      return {
        error: true,
        message: `Error al enviar correo de prueba de cuota: ${response.statusText}`,
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Error sending test quota email:", error);
    throw error;
  }
}